import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";
import logoIbiomed from "@/assets/logo-ibiomed.png";

const navigation = [
  { name: "Home", href: "/" },
  { name: "Tratamentos", href: "/tratamentos" },
  { name: "Ensino & Cursos", href: "/ensino-cursos" },
  { name: "Profissionais", href: "/profissionais" },
  { name: "TV Ibiomed", href: "/tv-ibiomed" },
  { name: "Projeto Social", href: "/projeto-social" },
];

export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-effect border-b border-border/50">
      <div className="container-elegant">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={logoIbiomed} 
              alt="IBIOMED - Instituto Biomédico" 
              className="h-12 md:h-14 w-auto"
              width={154}
              height={48}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium tracking-wide transition-colors hover:text-primary ${
                  location.pathname === item.href
                    ? "text-primary"
                    : "text-muted-foreground"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="https://www.instagram.com/institutoibiomed?igsh=MXI4c3l1eDd2OXVheQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label="Instagram do Instituto IBIOMED"
            >
              <Instagram size={20} />
            </a>
            <Button asChild variant="default" size="sm">
              <a
                href="https://api.whatsapp.com/message/LVSHX74FFHBTI1?autoload=1&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                Agendar Consulta
              </a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-foreground"
            aria-label="Abrir menu de navegação"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-background border-t border-border"
          >
            <nav className="container-elegant py-6 flex flex-col gap-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsOpen(false)}
                  className={`text-base font-medium py-2 transition-colors ${
                    location.pathname === item.href
                      ? "text-primary"
                      : "text-muted-foreground"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-4 border-t border-border flex items-center gap-4">
                <a
                  href="https://www.instagram.com/institutoibiomed?igsh=MXI4c3l1eDd2OXVheQ=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors"
                  aria-label="Instagram do Instituto IBIOMED"
                >
                  <Instagram size={20} />
                </a>
                <Button asChild variant="default" className="flex-1">
                  <a
                    href="https://api.whatsapp.com/message/LVSHX74FFHBTI1?autoload=1&app_absent=0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Agendar Consulta
                  </a>
                </Button>
              </div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
